import type { Maintenance } from '../../context/MaintenanceProvider';
import { type Country, paymentMethodsByCountry } from '../../entities/Country';
import type { PaymentMethodType } from '../../entities/enums';

export const getDefaultPaymentMethod = (
  paymentMethod: PaymentMethodType,
  country: Country,
  maintenance: Array<Maintenance | undefined>,
): PaymentMethodType => {
  const config = paymentMethodsByCountry[country];

  const isPaymentEnabled = (maintenanceItem: Maintenance | undefined) =>
    !maintenanceItem?.disablePayment;

  const defaultPaymentMethod = config.find((pm) => {
    if (pm === 'Invoice') {
      return false; // Excluding the 'Invoice' payment method type
    }

    const maintenanceItem = maintenance?.find(
      (m) => m?.paymentMethod.toUpperCase() === pm.toUpperCase(),
    );

    return config.find(
      (method) => method === pm && isPaymentEnabled(maintenanceItem),
    );
  });

  return defaultPaymentMethod ?? paymentMethod;
};
